import styled from 'styled-components';

export const CommentsWrapper = styled.div`
    text-align: left;
`;
